import actions from './actions';

const initState = {
    bannerInfo: {},
    banners   : {
        data: []
    },
    bannerDeleted: false,
    loading : false,
};

export default function fetchBannersReducer(state = initState, action) {
    switch (action.type) {
        case actions.FETCH_BANNERS_REQUESTED:
            return {
                ...state,
                banners   : {
                    data: []
                },
                loading : true
            };
        case actions.FETCH_BANNERS_SUCCEEDED:
            return {
                ...state,
                banners    : action.banners,
                loading     : false
            };
        case actions.FETCH_BANNERS_FAILED:
            return {
                ...state,
                loading : false
            };
        case actions.FETCH_BANNER_REQUESTED:
            return {
                ...state,
                loading : true
            };
        case actions.FETCH_BANNER_SUCCEEDED:
            return {
                ...state,
                bannerInfo: action.banner,
                loading     : false
            };
        case actions.FETCH_BANNER_FAILED:
            return {
                ...state,
                loading : false
            };
        case actions.DELETE_BANNER_REQUESTED:
            return {
                ...state,
                loading : true
            };
        case actions.DELETE_BANNER_SUCCEEDED:
            return {
                ...state,
                bannerDeleted: true,
                loading     : false
            };
        case actions.DELETE_BANNER_FAILED:
            return {
                ...state,
                loading : false
            };
        default:
            return state;
    }
}
